<template>
    <v-card>
        <v-dialog v-model="modal">
            <history-modal :activeProbeId="activeProbeId"/>
        </v-dialog>
        <v-card-title>
            <v-text-field
                    v-model.trim="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="probesList"
                :items-per-page="20"
                class="elevation-1"
                :search="search"
                :loading="loading"
                loading-text="Loading stations"
                :custom-filter="customFilter"
                :page="tableOptions && tableOptions.page ? tableOptions.page : 1"
                :options.sync="options"
                :footer-props="footerProps"
                :server-items-length="probesCount"

        >
            <template v-slot:header.status="{  }">
                <v-menu v-model="showStatusMenu" :close-on-content-click="false" offset-y>
                    <template v-slot:activator="{ on }">
                        <span v-on="on" style="cursor: pointer; white-space: nowrap;">{{`Status (${selectedStatus})`}}</span>
                    </template>
                    <v-card class="px-5 py-2" style="z-index: 10">
                        <v-row>
                            <v-radio-group v-model="selectedStatus">
                                <v-radio
                                        v-for="status in statuses"
                                        :key="status"
                                        :label="`${status.charAt(0).toUpperCase() + status.slice(1)}`"
                                        :value="status"
                                        @click="handleFilterStatusesClick(); showStatusMenu = false">
                                    >
                                </v-radio>
                            </v-radio-group>
                        </v-row>
                    </v-card>
                </v-menu>
            </template>
            <template v-slot:item.status="{ item }">
                <v-tooltip bottom v-if="['error', 'warning'].includes(item.status)">
                    <template v-slot:activator="{ on }">
                        <v-chip v-on="on" :color="probeStatusText(item) === 'active' ? 'success' : probeStatusText(item) === 'error' ? 'error' : probeStatusText(item) === 'warning' ? 'orange' : 'grey lighten-2'">
                            {{ probeStatusText(item) | cleanString }}
                        </v-chip>
                    </template>
                    <p v-for="(error, i) in item.error_descriptions" :key="i">{{error}}</p>
                </v-tooltip>
                <template v-else>
                    <v-chip :color="probeStatusText(item) === 'active' ? 'success' : probeStatusText(item) === 'error' ? 'error' : probeStatusText(item) === 'warning' ? 'orange' : 'grey lighten-2'">
                        {{ probeStatusText(item) | cleanString }}
                    </v-chip>
                </template>
            </template>
            <template v-slot:item.history="{ item }">
                <v-btn
                        color="primary"
                        small
                        @click="openProbeHistory(item.id)"
                >
                    <span>History</span>
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import HistoryModalContent from "@/components/sensor/HistoryModalContent";
import debounce from 'debounce'

export default {
    name: "ProbeListTable",
    components: {
      'history-modal': HistoryModalContent
    },
    data() {
        return {
            modal: false,
            activeProbeId: null,
            search: '',
            options: this.tableOptions,
            footerProps: {"items-per-page-options": [20, 50, 100, 500]},
            statuses: ['all', 'active', 'inactive', 'error', 'warning'],
            showStatusMenu: false,
            selectedStatus: 'all',
            headers: [
                {
                    text: 'Probe name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Long alias',
                    align: 'start',
                    sortable: false,
                    value: 'long_alias',
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                },
                {
                    text: '',
                    align: 'center',
                    sortable: false,
                    value: 'history',
                }
            ],
        }
    },
    watch: {
        async search() {
            await this.setSearchString(this.search);
            this.debouncedSearch(this.search);
        },
        options(val) {
            this.setTableOptions(val);
        },
    },
    created() {
        this.setQueryStatus(this.selectedStatus);

        this.debouncedSearch = debounce(() => {
            this.setTableOptions({...this.tableOptions, page: 1});
        }, 300)
    },
    computed: {
        ...mapState('probe', ['probesList', 'loading', 'tableOptions', 'probesCount', 'queryStatus'])
    },
    methods: {
        ...mapActions('probe', ['fetchProbeList', 'toggleProbeUseForMap']),
        ...mapMutations('probe', ['setTableOptions', 'setSearchString', 'setQueryStatus']),
        customFilter(items) {
            return items;
        },
        handleFilterStatusesClick() {
            this.setQueryStatus(this.selectedStatus);
            this.setTableOptions({...this.tableOptions, page: 1});
        },
        probeStatusText(probe) {
            if (this.selectedStatus !== 'all') return this.selectedStatus
            return probe.status
        },
        openProbeHistory(probeId){
            this.modal = true
            this.activeProbeId = probeId
        }
    }
}
</script>

<style scoped>

</style>